<template>
    <div class="mvt-inputrange" :changed="changed" :class="{'editable': !options.readonly}">
        <mvtCheckbox class="small m-b-1" v-if="extraData && extraData.length ===1" :data="extraData" v-model="extralValue"/>
        <div class="mvt-inputrange-input">
            <div class="input min" :class="theme || 'small'">
                <component :is="options.input" ref="min" v-model="minValue" @actived="checkMax" :changed="minChanged" :placeholder="options.placeholderMin"></component>
            </div>
            <span>-</span>
            <div class="input max" :class="theme || 'small'">
                <component :is="options.input" ref="max" v-model="maxValue" @actived="checkMin" :changed="maxChanged" :placeholder="options.placeholderMax"></component>
            </div>
        </div>
        <mvtRangeSlider ref="rangeSlider" v-if="rangeSliderData && rangeSliderData.length" v-model="rangeValue" :options="rangeSliderOptions" :data="rangeSliderData"></mvtRangeSlider>
    </div>
</template>

<script src="./mvt-inputrange.js"></script>

<style lang="scss">
    @use "./mvt-inputrange.scss" as *;
</style>